export function updateLocale(locale: string) {
  const currentCountry = window.Shopify.country;

  if (currentCountry === locale) {
    return;
  }

  const formId = crypto.randomUUID();
  const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="source" value="geolocation_selector">
      <input name="country_code" value="${locale}">
      <input name="return_to" value="${window.location.pathname}">
    </form>
  `;

  // eslint-disable-next-line no-console
  console.log(`Updating locale to "${locale}"...`);

  document.body.insertAdjacentHTML('beforeend', formHtml);
  (document.getElementById(formId) as HTMLFormElement).submit();
}

function updateSchoolRegion() {
  const shouldUpdateRegion = window.localStorage.getItem('force-school-region') === 'true';
  const newRegion = window.currentCustomer?.countryId;

  if (shouldUpdateRegion && newRegion) {
    window.localStorage.removeItem('force-school-region');

    // Taking first two characters of the country code to convert AUD -> AU
    updateLocale(newRegion.substring(0, 2));
  }
}

window.addEventListener('load', () => {
  updateSchoolRegion();
});
